// How an image section renders on each surface.
//   'both'  – image + text
//   'text'  – text only (image hidden on this surface)
//   'image' – image only (text hidden on this surface)
//
// Authors set section.talkLayout / section.slideLayout explicitly in the editor.
// When those are missing (older talks) we fall back to the historical behaviour:
// show text wherever the section actually has text, otherwise show just the image.

export const LAYOUT_MODES = ["both", "text", "image"];
const isMode = (v) => LAYOUT_MODES.includes(v);

const stripHtml = (html) =>
    String(html || "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .trim();

export function sectionHasImage(section) {
    return String(section?.imageUrl || "").trim() !== "";
}

// Combined talk-page text (body + any continuation bodies).
export function talkText(section) {
    const parts = [];
    if (section?.body) parts.push(section.body);
    if (Array.isArray(section?.bodies)) section.bodies.forEach((p) => p && parts.push(p));
    return parts.join("\n");
}

// Text used for the slideshow: the custom slide text if the author wrote one,
// otherwise the talk-page text.
export function slideText(section) {
    if (typeof section?.slideBody === "string" && section.slideBody.trim() !== "") {
        const parts = [section.slideBody];
        if (Array.isArray(section?.slideBodies)) section.slideBodies.forEach((p) => p && parts.push(p));
        return parts.join("\n");
    }
    return talkText(section);
}

export function talkImageMode(section) {
    if (isMode(section?.talkLayout)) return section.talkLayout;
    if (!sectionHasImage(section)) return "text";
    const hasText = stripHtml(talkText(section)) !== "" || Boolean(section?.includeText);
    return hasText ? "both" : "image";
}

export function slideImageMode(section) {
    if (isMode(section?.slideLayout)) return section.slideLayout;
    if (!sectionHasImage(section)) return "text";
    return stripHtml(slideText(section)) !== "" ? "both" : "image";
}
